import React from "react";
import { FieldArray, Field } from "formik";
import { useTranslation } from "react-i18next";

export function normalizeSizesFromApi(sizes) {
  if (!Array.isArray(sizes) || sizes.length === 0) return [{ title: "" }];
  return sizes.map((s) =>
    typeof s === "string" ? { title: s } : { title: (s && s.title) || "" }
  );
}

export function sizesForSubmit(sizes) {
  if (!Array.isArray(sizes)) return [];
  return sizes
    .map((s) => ({ title: (s && s.title && String(s.title).trim()) || "" }))
    .filter((s) => s.title);
}

const MultiSizeFieldArray = ({ name = "sizes", values, errors }) => {
  const { t } = useTranslation();
  const list = values[name] || [{ title: "" }];

  return (
    <div className="col-lg-12 text-center form-group">
      <label className="text-left d-flex">{t("list_heading_size")}</label>
      <FieldArray name={name}>
        {({ push, remove }) => (
          <div className="col-12 mb-2 text-start">
            <div className="row">
              {list.map((_, index) => (
                <div key={index} className="col-12 mb-2">
                  <div className="w-100 p-2 bg-group">
                    <div className="row align-items-start">
                      <div className="col-md-10">
                        <Field
                          name={`${name}.${index}.title`}
                          placeholder="Enter size"
                          className="form-control"
                        />
                        <span className="text-danger">
                          {errors[name]?.[index]?.title}
                        </span>
                      </div>
                      <div className="col-md-2">
                        <button
                          type="button"
                          className="btn btn-danger me-2"
                          onClick={() => remove(index)}
                          disabled={list.length === 1}
                        >
                          Remove
                        </button>
                        {index === list.length - 1 && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => push({ title: "" })}
                          >
                            Add
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </FieldArray>
      {typeof errors[name] === "string" ? (
        <span className="text-danger d-flex text-left">{errors[name]}</span>
      ) : null}
    </div>
  );
};

export default MultiSizeFieldArray;
